/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5-2.438 0-4.682-.831-6.4642-2.2251L20.2749 5.5358C21.669 7.3179 22.5 9.5619 22.5 12ZM4.4217 19.2677l14.846-14.846C17.3812 2.612 14.8205 1.5 12 1.5 6.201 1.5 1.5 6.201 1.5 12c0 2.8205 1.112 5.3812 2.9217 7.2677ZM24 12c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0s12 5.3726 12 12Z"
    clipRule="evenodd"
  />,
  'Clear'
);
